"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PUSHTypes_1 = require("../PUSHTypes");
const SubscribePoolBettingSummary_1 = require("./calls/SubscribePoolBettingSummary");
const SubscribeRaceInformation_1 = require("./calls/SubscribeRaceInformation");
const SubscribeRacePools_1 = require("./calls/SubscribeRacePools");
const SubscribeCardTaggedValueChanges_1 = require("./calls/SubscribeCardTaggedValueChanges");
const SubscribeRaceTaggedValueChanges_1 = require("./calls/SubscribeRaceTaggedValueChanges");
const SubscribeGenericTaggedValueChanges_1 = require("./calls/SubscribeGenericTaggedValueChanges");
const AAPITypes_1 = require("./AAPITypes");
const AAPIClient_1 = __importDefault(require("./AAPIClient"));
class AAPIPoolsClient extends AAPIClient_1.default {
    constructor(params) {
        super(params);
        this._subscribedCard = {};
        this._subscribedCardILDelegates = {};
        this._subscribedCardDeltaDelegates = {};
        this._subscribedRace = {};
        this._subscribedRaceILDelegates = {};
        this._subscribedRaceDeltaDelegates = {};
        this._subscribedRacePool = {};
        this._subscribedRacePoolILDelegates = {};
        this._subscribedRacePoolDeltaDelegates = {};
        this._subscribedRunner = {};
        this._subscribedRunnerILDelegates = {};
        this._subscribedRunnerDeltaDelegates = {};
        this._subscribedCTV = {};
        this._subscribedCTVILDelegates = {};
        this._subscribedCTVDeltaDelegates = {};
        this._subscribedRTV = {};
        this._subscribedRTVILDelegates = {};
        this._subscribedRTVDeltaDelegates = {};
        this._subscribedGTV = {};
        this._subscribedGTVILDelegates = {};
        this._subscribedGTVDeltaDelegates = {};
        this._subscribedAsyncResponse = {};
        this._subscribedAsyncResponseILDelegates = {};
        this._subscribedAsyncResponseDeltaDelegates = {};
        this._topicHandlersLocal = {
            [AAPITypes_1.aapiId.setAnonymousSessionContext]: this.standardCallResponse,
            [AAPITypes_1.aapiId.logonPunter]: this.standardCallResponse,
            [AAPITypes_1.aapiId.logoffPunter]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribePoolBettingSummary]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribeRaceInformation]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribeRacePools]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribeCardTaggedValueChanges]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribeRaceTaggedValueChanges]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribeGenericTaggedValueChanges]: this.standardCallResponse,
            [AAPITypes_1.aapiId.subscribeAsynchronousResponse]: this.standardCallResponse,
            [AAPITypes_1.aapiId.unsubscribe]: this.standardCallResponse,
            [AAPITypes_1.aapiId.listSubscriptions]: this.standardCallResponse,
        };
        this._regexPoolsArrayLocal = [
            {
                regex: /^C\/([0-9]*)$/,
                method: this._onChangeCard,
            },
            {
                regex: /^C\/([0-9]*)\/NCD$/,
                method: this._onNewCard,
            },
            {
                regex: /^R\/([0-9]*)$/,
                method: this._onChangeRace,
            },
            {
                regex: /^R\/([0-9]*)\/NRD$/,
                method: this._onNewRace,
            },
            {
                regex: new RegExp('^R/([0-9]*)/RU/([0-9]*)$'),
                method: this._onChangeRunner,
            },
            {
                regex: new RegExp('^C/([0-9]*)/CTV/(.*)$'),
                method: this._onChangeCardTaggedValue,
            },
            {
                regex: new RegExp('^R/([0-9]*)/RTV/(.*)$'),
                method: this._onChangeRaceTaggedValue,
            },
            {
                regex: new RegExp('^RP/([0-9]*)$'),
                method: this._onChangeRacePool,
            },
            {
                regex: new RegExp('^GTV/(.*)$'),
                method: this._onChangeGenericTaggedValue,
            },
            {
                regex: new RegExp('^ASR/(.*)$'),
                method: this._onReceiveAsyncResponse,
            },
        ];
        this.subscribePoolBettingSummary = SubscribePoolBettingSummary_1.subscribePoolBettingSummary.bind(this);
        this.subscribeRaceInformation = SubscribeRaceInformation_1.subscribeRaceInformation.bind(this);
        this.subscribeRacePools = SubscribeRacePools_1.subscribeRacePools.bind(this);
        this.subscribeCardTaggedValueChanges = SubscribeCardTaggedValueChanges_1.subscribeCardTaggedValueChanges.bind(this);
        this.subscribeRaceTaggedValueChanges = SubscribeRaceTaggedValueChanges_1.subscribeRaceTaggedValueChanges.bind(this);
        this.subscribeGenericTaggedValueChanges = SubscribeGenericTaggedValueChanges_1.subscribeGenericTaggedValueChanges.bind(this);
        this.extendRegex(this._regexPoolsArrayLocal);
        //this.extendTopicHandlers(this._topicHandlersLocal);
    }
    getOrCreateSubscribedCard(cardId) {
        this._subscribedCard[cardId] =
            this._subscribedCard[cardId] || new AAPITypes_1.SubscribedCard();
        return this._subscribedCard[cardId];
    }
    getOrCreateSubscribedRace(raceId) {
        this._subscribedRace[raceId] =
            this._subscribedRace[raceId] || new AAPITypes_1.SubscribedRace();
        return this._subscribedRace[raceId];
    }
    getOrCreateSubscribedRacePool(poolId) {
        this._subscribedRacePool[poolId] =
            this._subscribedRacePool[poolId] || new AAPITypes_1.SubscribedRacePool();
        return this._subscribedRacePool[poolId];
    }
    getOrCreateSubscribedRunner(runnerId) {
        this._subscribedRunner[runnerId] =
            this._subscribedRunner[runnerId] || new AAPITypes_1.SubscribedRunner();
        return this._subscribedRunner[runnerId];
    }
    getOrCreateSubscribedCTV(topicName) {
        this._subscribedCTV[topicName] =
            this._subscribedCTV[topicName] || new AAPITypes_1.SubscribedCTV();
        return this._subscribedCTV[topicName];
    }
    getOrCreateSubscribedRTV(topicName) {
        this._subscribedRTV[topicName] =
            this._subscribedRTV[topicName] || new AAPITypes_1.SubscribedRTV();
        return this._subscribedRTV[topicName];
    }
    getOrCreateSubscribedGTV(topicName) {
        this._subscribedGTV[topicName] =
            this._subscribedGTV[topicName] || new AAPITypes_1.SubscribedGTV();
        return this._subscribedGTV[topicName];
    }
    getOrCreateSubscribedAsyncResponse(topicName) {
        this._subscribedAsyncResponse[topicName] =
            this._subscribedAsyncResponse[topicName] || new AAPITypes_1.SubscribedAsyncResponse();
        return this._subscribedAsyncResponse[topicName];
    }
    _onChangeRunner({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*
            var runnerId = regExMatches[2];
            var thisRunner = getOrCreateSubscribedRunner(runnerId);
    
            if (response.header.messageType === gec.messageType.Delete) {
                thisRunner.prototype.resetFiredDelegates();
                return;
            }
    
            thisRunner.runnerId = response.body.runnerId;
            thisRunner.runnerStatus = response.body.runnerStatusId;
            thisRunner.currentWinPrice = response.body.currentWinPrice;
            thisRunner.currentWinFractionalOdds = response.body.currentWinFractionalOdds;
            thisRunner.priceTrendType = response.body.priceTrendType;
            thisRunner.finishPosition = response.body.finishPosition;
    
            thisRunner.jockey = response.body.jockey;
            thisRunner.changedJockeyName = response.body.changedJockeyName;
    
            thisRunner.trainer = response.body.trainer;
            thisRunner.changedTrainer = response.body.changedTrainer;
    
            thisRunner.equipment = response.body.equipment;
            thisRunner.changedEquipment = response.body.changedEquipment;
    
            thisRunner.medication = response.body.medication;
            thisRunner.changedMedication = response.body.changedMedication;
    
            thisRunner.horseSex = response.body.horseSex;
            thisRunner.changedHorseSex = response.body.changedHorseSex;
    
            thisRunner.weightCarried = response.body.weightCarried;
            thisRunner.changedWeightCarried = response.body.changedWeightCarried;
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    // Reset delegates so that when we re-subscribe to a race we were previously subscribed to, we want
                    // the IL delegates to fire again so that we get up-to-date odds (since IAPI odds can be cached
                    // by Cloudflare and may be stale)
                    thisRunner.prototype.resetFiredDelegates();
    
                    thisRunner.prototype.fireILDelegates(this._subscribedRunnerILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisRunner.prototype.fireDeltaDelegates(this._subscribedRunnerDeltaDelegates);
                    break;
            }
              */
    }
    _onChangeCard({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*
            var cardId = regExMatches[1];
            var thisCard = getOrCreateSubscribedCard(cardId);
    
            if (response.header.messageType === gec.messageType.Delete) {
                thisCard.prototype.resetFiredDelegates();
                return;
            }
    
            thisCard.cardId = response.body.cardId;
            thisCard.cardName = response.body.cardName;
            thisCard.cardDate = response.body.cardDate;
            thisCard.shortCardName = response.body.shortCardName;
            thisCard.abbreviatedCardName = response.body.abbreviatedCardName;
            thisCard.breedCode = response.body.breedCode;
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisCard.prototype.fireILDelegates(this._subscribedCardILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisCard.prototype.fireDeltaDelegates(this._subscribedCardDeltaDelegates);
                    break;
            }
    
              */
    }
    _onNewCard({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*    var cardId = regExMatches[1];
            var thisCard = getOrCreateSubscribedCard(cardId);
    
            thisCard.cardId = cardId;
            thisCard.isNew = true;
    
            // Treat new cards as a delta (even though message type is InitialLoad)
            // since the "NCD" message always follows an InitialLoad
            thisCard.prototype.fireDeltaDelegates(this._subscribedCardDeltaDelegates);
    
              */
    }
    _onChangeRace({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*
            var raceId = regExMatches[1];
            var thisRace = getOrCreateSubscribedRace(raceId);
    
            if (response.header.messageType === gec.messageType.Delete) {
                thisRace.prototype.resetFiredDelegates();
                return;
            }
    
            thisRace.raceId = response.body.raceId;
            thisRace.postTime = response.body.postTime;
            thisRace.raceStatus = response.body.raceStatusId;
    
            thisRace.distance = response.body.distance;
            thisRace.changedDistance = response.body.changedDistance;
    
            thisRace.surface = response.body.surface;
            thisRace.changedSurface = response.body.changedSurface;
    
            thisRace.trackConditions = response.body.trackConditions;
            thisRace.changedTrackConditions = response.body.changedTrackConditions;
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisRace.prototype.fireILDelegates(this._subscribedRaceILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisRace.prototype.fireDeltaDelegates(this._subscribedRaceDeltaDelegates);
                    break;
            }
    
              */
    }
    _onNewRace({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*  var raceId = regExMatches[1];
            var thisRace = getOrCreateSubscribedRace(raceId);
    
            thisRace.raceId = raceId;
            thisRace.isNew = true;
    
            // Treat new races as a delta (even though message type is InitialLoad)
            // since the "NRD" message always follows an InitialLoad
            thisRace.prototype.fireDeltaDelegates(this._subscribedRaceDeltaDelegates);
    
              */
    }
    _onChangeRacePool({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*
            var poolId = regExMatches[1];
            var thisPool;
    
            thisPool = getOrCreateSubscribedRacePool(poolId);
    
            if (response.header.messageType === gec.messageType.Delete) {
                thisPool.prototype.resetFiredDelegates();
                return;
            }
    
            thisPool.poolId = response.body.poolId;
            thisPool.poolStatus = response.body.poolStatusId;
            thisPool.currentTotalBetPoolGross = response.body.currentTotalBetPoolGross;
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisPool.prototype.fireILDelegates(this._subscribedRacePoolILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisPool.prototype.fireDeltaDelegates(this._subscribedRacePoolDeltaDelegates);
                    break;
            }
      */
    }
    standardCallResponse(bodyObject) {
        const correlationId = Number(bodyObject.correlationId);
        const returnCode = Number(bodyObject.returnCode);
        const correlationData = this._correlationData[correlationId];
        if (returnCode === 0) {
            correlationData.callbackOnSuccess.call(this, bodyObject);
        }
        else {
            correlationData.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode: returnCode }));
        }
    }
    _onChangeCardTaggedValue({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*
            var thisCTV = this.getOrCreateSubscribedCTV(response.header.topicName);
    
            thisCTV.cardId = regExMatches[1];
            thisCTV.name = regExMatches[2];
    
            if (response.body) {
                thisCTV.value = response.body.value;
            } else {
                thisCTV.value = undefined;
            }
    
            // If initial load message has no body, blank out the name, as we should ignore this message
            if (response.header.messageType === gec.messageType.InitialLoad
                && response.body === undefined) {
                thisCTV.name = undefined;
            }
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisCTV.prototype.fireILDelegates(this._subscribedCTVILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisCTV.prototype.fireDeltaDelegates(this._subscribedCTVDeltaDelegates);
                    break;
                case gec.messageType.Delete:
                    thisCTV.prototype.fireDeltaDelegates(this._subscribedCTVDeltaDelegates);
                    thisCTV.prototype.resetFiredDelegates();
                    break;
            }
    
              */
    }
    _onChangeGenericTaggedValue({ headerMatches, bodyObject, }) {
        console.error(headerMatches, bodyObject);
        /*var thisGTV = getOrCreateSubscribedGTV(response.header.topicName);
    
        thisGTV.name = regExMatches[1];
        if (response.body) {
          thisGTV.value = response.body.value;
        } else {
          thisGTV.value = undefined;
        }
    
        // If initial load message has no body, blank out the name, as we should ignore this message
        if (
          response.header.messageType === gec.messageType.InitialLoad &&
          response.body === undefined
        ) {
          thisGTV.name = undefined;
        }
    
        /*switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisGTV.prototype.fireILDelegates(this._subscribedGTVILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisGTV.prototype.fireDeltaDelegates(this._subscribedGTVDeltaDelegates);
                    break;
                case gec.messageType.Delete:
                    thisGTV.prototype.fireDeltaDelegates(this._subscribedGTVDeltaDelegates);
                    thisGTV.prototype.resetFiredDelegates();
                    break;
            }  */
    }
    _onReceiveAsyncResponse({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*    var thisAsyncResponse = getOrCreateSubscribedAsyncResponse(response.header.topicName);
    
            if (response.body) {
                thisAsyncResponse.value = response.body;
            } else {
                thisAsyncResponse.value = undefined;
            }
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisAsyncResponse.prototype.fireILDelegates(this._subscribedAsyncResponseILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisAsyncResponse.prototype.fireDeltaDelegates(this._subscribedAsyncResponseDeltaDelegates);
                    break;
            }
            */
    }
    _onChangeRaceTaggedValue({ headerMatches, bodyObject }) {
        console.error(headerMatches, bodyObject);
        /*
            var thisRTV = getOrCreateSubscribedRTV(response.header.topicName);
    
            thisRTV.raceId = regExMatches[1];
            thisRTV.name = regExMatches[2];
            if (response.body) {
                thisRTV.value = response.body.value;
            } else {
                thisRTV.value = undefined;
            }
    
            // If initial load message has no body, blank out the name, as we should ignore this message
            if (response.header.messageType === gec.messageType.InitialLoad
                && response.body === undefined) {
                thisRTV.name = undefined;
            }
    
            switch (response.header.messageType) {
                case gec.messageType.InitialLoad:
                    thisRTV.prototype.fireILDelegates(this._subscribedRTVILDelegates);
                    break;
                case gec.messageType.Delta:
                    thisRTV.prototype.fireDeltaDelegates(this._subscribedRTVDeltaDelegates);
                    break;
                case gec.messageType.Delete:
                    thisRTV.prototype.fireDeltaDelegates(this._subscribedRTVDeltaDelegates);
                    thisRTV.prototype.resetFiredDelegates();
                    break;
            }
            */
    }
}
exports.default = AAPIPoolsClient;
